/** Свойства плинтуса комнаты: материал, высота профиля и удаление без подъёма над полом. */
import { baseboardLook, baseboardSection } from "@/shared/catalog";
import { useBaseboardStore } from "@/shared/store/layers";
import { UIKit } from "@/shared/ui";
import type { Room } from "@/widgets/plan";

interface Props {
	room: Room;
}

export const RoomBaseboardProperties = ({ room }: Props) => {
	const items = useBaseboardStore((state) => state.items);
	const setRoomBaseboardMaterial = useBaseboardStore((state) => state.setRoomBaseboardMaterial);
	const updateRoomBaseboard = useBaseboardStore((state) => state.updateRoomBaseboard);
	const removeRoomBaseboard = useBaseboardStore((state) => state.removeRoomBaseboard);
	const baseboard = items[room.id];
	const look = baseboard ? baseboardLook(baseboard) : null;

	return (
		<>
			<UIKit.Text className="text-sm font-semibold tracking-label text-ink uppercase">
				Плинтус комнаты
			</UIKit.Text>
			<div className="flex flex-col gap-1.5">
				{baseboardSection.items.map((item) => (
					<UIKit.Button
						key={item.id}
						type="button"
						className={`flex items-center justify-between rounded-lg border px-2.5 py-2 text-left text-sm transition-colors ${baseboard?.material === item.material ? "border-accent bg-accent-soft text-accent" : "border-border bg-surface text-ink hover:border-slate-300"}`}
						onClick={() => setRoomBaseboardMaterial(room.id, item.material)}
					>
						<UIKit.Text as="span" className="flex items-center gap-2">
							<UIKit.Text
								as="span"
								className="size-2.5 rounded-sm"
								style={{ background: item.color }}
							/>
							{item.name}
						</UIKit.Text>
						{baseboard?.material === item.material ? "выбран" : ""}
					</UIKit.Button>
				))}
			</div>
			{baseboard && look && (
				<>
					<UIKit.NumberField
						label="Высота плинтуса"
						value={look.height}
						min={40}
						max={250}
						step={10}
						onChange={(height) => updateRoomBaseboard(room.id, { height })}
					/>
					<label className="flex flex-col gap-1 text-xs text-ink">
						Цвет плинтуса
						<UIKit.ColorPicker
							label=""
							value={look.color}
							onChange={(color) => updateRoomBaseboard(room.id, { color })}
						/>
					</label>
					<UIKit.Button
						type="button"
						className="text-sm text-red-700 hover:text-red-800"
						onClick={() => removeRoomBaseboard(room.id)}
					>
						Убрать плинтус
					</UIKit.Button>
				</>
			)}
		</>
	);
};
